<mat-sidenav-container>

  <mat-sidenav [opened]="false" mode="over" #sidenav class="sidenav mat-elevation-z6">
    <button mat-icon-button color="warn" class="close" (click)="sidenav.close()">
      <mat-icon color="warn">close</mat-icon>
    </button>
    <div class="divider"></div>
    <div *ngIf="sidenavMenuItems.length > 0">
      <app-sidenav-menu [menuItems]="sidenavMenuItems" [menuParentId]="0"></app-sidenav-menu>
    </div>
      <div class="divider"></div>
      <div class="text-center py-2">
        <a href="https://m.vk.com/only_woman">
          <svg class="social-icon" viewBox="0 0 24 24">
            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm.25 16.996h-2.134c-1.205 0-1.409-.687-2.401-1.679-.897-.897-1.395-.209-1.374 1.068.006.339-.161.611-.566.611-1.264 0-3.08.178-4.918-1.806-1.883-2.033-3.857-6.111-3.857-6.513 0-.237.196-.344.524-.344h2.17c.574 0 .623.284.783.649.667 1.521 2.265 4.574 2.69 2.87.244-.978.344-3.245-.703-3.44-.594-.11.452-.746 1.968-.746.377 0 .786.041 1.205.137.769.179.771.523.761 1.026-.039 1.903-.269 3.184.233 3.507.479.31 1.739-1.717 2.403-3.281.183-.433.219-.722.734-.722h2.654c1.39 0-.182 1.997-1.383 3.557-.968 1.255-.916 1.28.209 2.324.803.744 1.75 1.76 1.75 2.336.002.272-.21.446-.748.446z" />
          </svg>
        </a>
        <a href="https://www.instagram.com/thaicos__/">
          <svg class="social-icon" viewBox="0 0 24 24">
            <path d="M15.233 5.488c-.843-.038-1.097-.046-3.233-.046s-2.389.008-3.232.046c-2.17.099-3.181 1.127-3.279 3.279-.039.844-.048 1.097-.048 3.233s.009 2.389.047 3.233c.099 2.148 1.106 3.18 3.279 3.279.843.038 1.097.047 3.233.047 2.137 0 2.39-.008 3.233-.046 2.17-.099 3.18-1.129 3.279-3.279.038-.844.046-1.097.046-3.233s-.008-2.389-.046-3.232c-.099-2.153-1.111-3.182-3.279-3.281zm-3.233 10.62c-2.269 0-4.108-1.839-4.108-4.108 0-2.269 1.84-4.108 4.108-4.108s4.108 1.839 4.108 4.108c0 2.269-1.839 4.108-4.108 4.108zm4.271-7.418c-.53 0-.96-.43-.96-.96s.43-.96.96-.96.96.43.96.96-.43.96-.96.96zm-1.604 3.31c0 1.473-1.194 2.667-2.667 2.667s-2.667-1.194-2.667-2.667c0-1.473 1.194-2.667 2.667-2.667s2.667 1.194 2.667 2.667zm4.333-12h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm.952 15.298c-.132 2.909-1.751 4.521-4.653 4.654-.854.039-1.126.048-3.299.048s-2.444-.009-3.298-.048c-2.908-.133-4.52-1.748-4.654-4.654-.039-.853-.048-1.125-.048-3.298 0-2.172.009-2.445.048-3.298.134-2.908 1.748-4.521 4.654-4.653.854-.04 1.125-.049 3.298-.049s2.445.009 3.299.048c2.908.133 4.523 1.751 4.653 4.653.039.854.048 1.127.048 3.299 0 2.173-.009 2.445-.048 3.298z" />
          </svg>
        </a>
      </div>
  </mat-sidenav>

  <mat-toolbar color="primary">
    <mat-toolbar-row fxLayoutAlign="space-between center" class="top-toolbar theme-container">
      <span fxHide="false" fxHide.gt-sm>
        <button mat-button (click)="sidenav.toggle()" class="sidenav-toggle">
          <mat-icon>menu</mat-icon>
        </button>
      </span>
      <span fxShow="false" fxShow.gt-xs fxLayoutAlign="center center"><mat-icon class="mat-icon-sm">call</mat-icon>  Горячая линия: +7 (918) 011 53 53 </span>
      <span fxShow="false" fxShow.gt-sm>Добро пожаловать в наш магазин!</span>
      <app-top-menu></app-top-menu>
    </mat-toolbar-row>
    <mat-toolbar-row fxLayoutAlign="space-between center" class="logo-toolbar theme-container">

      <div fxFlex="20" >
        <a class="logo" routerLink="/" (click)="closeSubMenus()"><img src="assets/images/label.png" class="logoImg"></a>
      </div>
      <div fxFlex fxShow="false" fxShow.gt-sm>
        <form method="get" class="search-form" fxLayout="row">
          <button mat-raised-button [matMenuTriggerFor]="categoriesMenu" #categoriesMenuTrigger="matMenuTrigger" type="button" class="mat-elevation-z0 categories text-truncate text-muted">Категории<mat-icon>arrow_drop_down</mat-icon></button>
          <mat-menu #categoriesMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="categories-dropdown">
            <span (mouseleave)="categoriesMenuTrigger.closeMenu()">
              <app-category-list [categories]="categories" [categoryParentId]="0" ></app-category-list>
            </span>
          </mat-menu>
          <input type="text" id="searchText" placeholder="Поиск..." fxFlex>
          <button mat-mini-fab (click)="search()" type="button" class="search-btn mat-elevation-z0 text-muted">
            <mat-icon>search</mat-icon>
          </button>
        </form>



      </div>
      <div fxFlex="20" fxLayout="row" fxLayoutAlign="end center">
        <div fxLayoutAlign="center center">
          <button mat-button [matMenuTriggerFor]="cartMenu" #cartMenuTrigger="matMenuTrigger" class="flex-row-button">
            <mat-icon class="mat-icon-lg">shopping_cart</mat-icon>
            <span *ngIf="appService.Data.totalCartCount > 0" class="cart-items-count">{{appService.Data.totalCartCount}}</span>
            <div fxLayout="column" fxLayoutAlign="center center" fxShow="false" fxShow.gt-xs class="top-cart">
              <span>Корзина</span>
              <span *ngIf="appService.Data.totalCartCount > 0">
                <bdi>
                  {{appService.Data.totalCartCount}} шт. -
                  {{getUserCurrencySign()}}<span>{{getCartTotalPrice(appService.Data.totalCartPrice) | number : '1.2-2'}}</span>
                </bdi>
              </span>
            </div>
            <mat-icon class="mat-icon-sm">arrow_drop_down</mat-icon>
          </button>
          <mat-menu #cartMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="top-menu-dropdown cart-dropdown">
            <ng-template matMenuContent>
              <span (mouseleave)="cartMenuTrigger.closeMenu()" class="d-block">
                <div fxLayout="row" fxLayoutAlign="space-between center" class="text-muted">
                  <b><span>{{appService.Data.totalCartCount}} шт.</span></b>
                  <b><a [routerLink]="['/cart']" class="text-muted">Перейти</a></b>
                </div>
                <div class="divider mt-1"></div>
                <div *ngIf="appService.Data.totalCartCount == 0" class="py-1 text-muted text-center">Ваша корзина пуста.</div>
                <mat-list>
                  <mat-list-item *ngFor="let product of appService.Data.cartList">
                    <h3 matLine class="text-muted"> {{product.productName}} </h3>
                    <p matLine class="text-muted">
                      <bdi *ngIf="product.isDiscount != 'Yes'">{{product.cartCount}} x {{getUserCurrencySign()}}{{getProductPrice(product.price) | number : '1.2-2'}}</bdi>
                      <bdi *ngIf="product.isDiscount == 'Yes'">{{product.cartCount}} x {{getUserCurrencySign()}}{{getProductDiscountPrice(product.price, product.discountPerc ) | number : '1.2-2'}}</bdi>
                    </p>
                    <img [src]="product.productImagesURL[0].small" alt="image">
                    <button mat-icon-button color="warn" class="remove" (click)="removeProduct(product); stopClickPropagate($event)" matTooltip="Убрать" matTooltipPosition="before">
                      <mat-icon class="mat-icon-sm">close</mat-icon>
                    </button>
                  </mat-list-item>
                </mat-list>
                <div *ngIf="appService.Data.cartList.length > 0" class="cart-dropdown-footer">
                  <div class="divider mt-1"></div>
                  <div fxLayout="row" fxLayoutAlign="space-between center" class="text-muted mt-1">
                    <b>ИТОГО:</b>
                    <b class="new-price">{{getUserCurrencySign()}}{{getCartTotalPrice(appService.Data.totalCartPrice) | number : '1.2-2'}}</b>
                  </div>
                  <div class="divider mt-1"></div>
                  <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-1">
                    <button mat-mini-fab color="warn" (click)="clearCart(); stopClickPropagate($event)" matTooltip="Отчистить корзину" matTooltipPosition="after">
                      <mat-icon>remove_shopping_cart</mat-icon>
                    </button>
                    <button mat-mini-fab color="primary" matTooltip="Сохранить и оплатить" matTooltipPosition="before" (click)="goToCheckout()">
                      <mat-icon>check</mat-icon>
                    </button>
                  </div>
                </div>
              </span>
            </ng-template>
          </mat-menu>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>


  <app-menu [categories]="categories" fxShow="false" fxShow.gt-sm></app-menu>


  <div class="theme-container main">
    <app-breadcrumb></app-breadcrumb>
    <router-outlet></router-outlet>
  </div>


  <app-footer></app-footer>

  <div *ngIf="showBackToTop" fxLayout="row" fxLayoutAlign="center center" class="back-to-top transition" (click)="scrollToTop()">
    <mat-icon>arrow_upward</mat-icon>
  </div>

</mat-sidenav-container>
